/**
 * Kroki obsługi zapytania w sklepie katalogowym — „Jak to działa".
 *
 * Jedno źródło dla sekcji na stronie głównej (CatalogHowItWorks) i zakładki
 * na karcie produktu, która zastępuje tam sklepowe „Dostawa / Zwroty /
 * Płatności". Karta nie może obiecywać niczego ponad to, co mówi strona
 * główna — wspólna treść gwarantuje to z definicji.
 *
 * Treść opisuje proces obsługi, nie asortyment, więc nie zmienia się przy
 * publikacji katalogu z EasyItem.
 */
export const CATALOG_HOW_IT_WORKS_STEPS = [
  {
    title: 'Wybierz produkty',
    text: 'Przeglądaj katalog i dodawaj interesujące pozycje do listy zapytania. Możesz zebrać kilkanaście produktów naraz.',
  },
  {
    title: 'Wyślij zapytanie',
    // Bez wyboru techniki w formularzu (20.10.2026) — dobiera ją handlowiec.
    text: 'Podaj nakład dla każdej pozycji i dane firmy. Technikę znakowania dobierzemy przy wycenie — możesz też opisać ją w zapytaniu.',
  },
  {
    title: 'Otrzymasz wycenę',
    text: 'Odpowiadamy zwykle w ciągu jednego dnia roboczego, z ceną za sztukę dla podanego nakładu.',
  },
  {
    title: 'Akceptacja i realizacja',
    text: 'Po zatwierdzeniu wyceny i projektu znakowania przechodzimy do produkcji i ustalamy termin dostawy.',
  },
] as const
